package ui.widget

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Chat_question
import org.jetbrains.compose.resources.StringResource
import tools.rememberString


@Composable
fun EditorCardWrapper(
    icon: ImageVector,
    title: StringResource,
    tooltip: StringResource,
    modifier: Modifier = Modifier,
    bodyPadding: Dp = 8.dp,
    body: @Composable () -> Unit
) {
    EditorCardWrapper(
        title = title.rememberString(),
        tooltip = tooltip,
        tooltipTitle = title,
        modifier = modifier,
        bodyPadding = bodyPadding,
        body = body
    ) {
        Icon(
            imageVector = icon,
            contentDescription = null
        )
    }
}

@Composable
fun EditorCardWrapper(
    icon: Long,
    title: StringResource,
    tooltip: StringResource,
    modifier: Modifier = Modifier,
    bodyPadding: Dp = 8.dp,
    body: @Composable () -> Unit
) {
    EditorCardWrapper(
        title = title.rememberString(),
        tooltip = tooltip,
        tooltipTitle = title,
        bodyPadding = bodyPadding,
        modifier = modifier,
        body = body
    ) {
        LazyIcon(
            id = icon,
            modifier = Modifier.size(24.dp)
        )
    }
}

@Composable
fun EditorCardWrapper(
    icon: ImageVector,
    title: String,
    tooltip: StringResource,
    tooltipTitle: StringResource,
    modifier: Modifier = Modifier,
    bodyPadding: Dp = 8.dp,
    body: @Composable () -> Unit
) {
    EditorCardWrapper(
        title = title,
        tooltip = tooltip,
        tooltipTitle = tooltipTitle,
        modifier = modifier,
        bodyPadding = bodyPadding,
        body = body
    ) {
        Icon(
            imageVector = icon,
            contentDescription = null
        )
    }
}

@Composable
private fun EditorCardWrapper(
    title: String,
    tooltip: StringResource,
    tooltipTitle: StringResource,
    modifier: Modifier = Modifier,
    bodyPadding: Dp,
    body: @Composable () -> Unit,
    icon: @Composable () -> Unit,
) {
    val tooltipState = DialogState.remember(key = "tooltip:${tooltipTitle.key}:${tooltip.key}")

    Card(modifier) {
        Column {
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier
                    .clip(CardDefaults.shape)
                    .clickable { tooltipState.show() }
                    .padding(8.dp)
            ) {
                icon()
                Text(
                    text = title,
                    modifier = Modifier.align(Alignment.CenterVertically)
                        .weight(1F),
                    style = MaterialTheme.typography.labelLarge
                )
                Icon(
                    imageVector = Svg.Chat_question,
                    contentDescription = null
                )
            }
            Space(4.dp)
            Column(
                modifier = Modifier.padding(horizontal = bodyPadding).padding(bottom = bodyPadding),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                body()
            }
        }
    }

    TooltipDialog(
        state = tooltipState,
        title = tooltipTitle,
        message = tooltip
    )
}